import clsx from 'clsx'
import { OdinIcon } from '@/components/ui/odin/odin-icon'

type QuestionChipProps = {
  question: string
  onClick: () => void
  disabled?: boolean
  animationDelayMs?: number
  className?: string
}

export const QuestionChip = ({ question, onClick, disabled, animationDelayMs = 0, className }: QuestionChipProps) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick}
    title={question}
    className={clsx(
      'animate-fade-slide-in inline-flex max-w-full items-start gap-2 rounded-2xl px-3.5 py-2 text-left text-sm opacity-0',
      'border border-border bg-muted/50 text-foreground',
      'transition-all duration-200',
      'hover:-translate-y-0.5 hover:border-primary',
      'disabled:cursor-not-allowed disabled:hover:translate-y-0',
      className,
    )}
    style={{ animationDelay: `${animationDelayMs}ms` }}
  >
    <OdinIcon icon={['far', 'sparkles']} className="mt-0.5 h-3.5 w-3.5 shrink-0 text-primary" />
    <span className="wrap-break-word">{question}</span>
  </button>
)
